import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=54b8aaf5&scoped=true&"
import script from "./AddButton.vue?vue&type=script&lang=ts&"
export * from "./AddButton.vue?vue&type=script&lang=ts&"
import style0 from "./AddButton.vue?vue&type=style&index=0&id=54b8aaf5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b8aaf5",
  null
  
)

export default component.exports